/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Input,Output,EventEmitter,Directive} from '@angular/core';
import { LayoutBaseComponent } from "../layout/layout-base.component";
import { environment } from '../../environments/environment';
import { TimerService } from 'src/refresh/service/timer-service';

@Directive()
export class ControlBaseComponent extends LayoutBaseComponent {

       public static errorClassByLang:string = "input-error-en ";

       protected _inputX:any;

       @Input ('ng-model')  set input( value: any) {
                this._inputX = value;
       }

       get input() {
           return this._inputX;
       }

       @Output('ng-modelChange')  inputChange = new EventEmitter<any>();
              
       @Input ("error-param")    errorParam: any;
       @Input ("error-if")       errorWhere: any;

       constructor(protected timerService:TimerService,protected controlType:number) {
                      super();
       }

       public _error:string;

       get  error():string {
            return this._error;
       }

       @Input ("ng-error") set error( theValue: string) {

              if ( theValue && theValue.endsWith("$") ) {

                  let  where = this.errorWhere;

                  if ( where === undefined  ) where = this.generalIf;

                  if ( where !== undefined  ) {

                        if ( typeof where  == 'string' ) {
                             if ( where ) theValue += where;
                        }
                        else
                        if ( where )  theValue += "Y";
                        else          theValue += "N";
                  }
              }

              this._error = theValue;

              if ( environment.production == false )  this.errorCode = theValue;
       }

       @Output("ng-errorChange") errorChange = new EventEmitter<string>();

       @Input ('ng-clear')       clearField: any;
       @Output("ng-clearChange") clearFieldChange = new EventEmitter<string>();


       public  _disable:boolean;

       @Input('ng-disable')  set  disable(value:boolean) {

              this._disable = value;
               
              if ( value )  {
                   //if ( typeof this.input == 'boolean' ) 
                   //     this.input = false;
                   //else this.input = "";

                   if ( this.label_class ) this.label_class += " disable-grey";
                        this.label_class = " disable-grey";

                   ///setTimeout( () => this.inputChange.emit(this.input),1);                
              }
              else {
                   let idx = this.label_class.indexOf("disable-grey");
                   if ( idx >= 0 ) {
                        this.label_class = this.label_class.substring(0,idx).trim();
                   }
              }
       }

       get disable():boolean {
              return this._disable;
       }
       
       public get errorClass():string {
              return "input-error " + ControlBaseComponent.errorClassByLang + this.error_class;
       }

       @Input ("error-class")  error_class: string = "";
       @Input ("error-style")  errorStyle: string;
        
       public get hintClass():string {
            return "hint-text " + this.hint_class;
       }
       @Input ('hint-text')        hintText: string;
       @Input ('hint-class')       hint_class: string = "";
       @Input ('hint-style')       hintStyle: string;
       @Input ('hint-param')       hintParam: string;

       public errorCode:string = "";

       public asIsOrder(a, b) {
              return 0;
       }  


       protected errorParamSet() {

             super.labelCheck();
             
             if ( this.input === undefined ) {
                 // console.log("*undef*", this.id, "*"+(this.error||''))
             }

             if ( this.errorParam && this.errorParam.length >= 0  ) {
                 if ( this.errorParam.charAt(0) == '{' ) {
                      this.errorParam = eval("("+this.errorParam+")");
                 }
             }          

             if ( this.labelParam && this.labelParam.length >= 0  ) {
                  if ( this.labelParam.charAt(0) == '{' ) {
                       this.labelParam = eval("("+this.labelParam+")");
                  }
             }          

             if ( this.hintParam && this.hintParam.length >= 0  ) {
                  if ( this.hintParam.charAt(0) == '{' ) {
                       this.hintParam = eval("("+this.hintParam+")");
                  }
             }          
       }

       public valueChanged() {

            if ( this.controlType != 3 ) {
                 this.inputChange.emit(this.input); 
                 this.timerService.reset();
            }

            if ( this.error ) {
                 this.errorChange.emit("");
                 this.error = null;
            }

            if ( this.clearField ) {
                 this.clearField = null;
                 this.clearFieldChange.emit(this.clearField);
            }
       }
}





